$(document).ready(function () {
    if (window.matchMedia('(max-width: 768px)').matches) {
        $(
            '.in-formular .sheetReferences, .in-form-rosty-na-miru .sheetReferences, .in-form-postele-na-miru .sheetReferences, .in-form-matrace-na-miru .sheetReferences'
        ).slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            adaptiveHeight: true
        })
    }
})
